<template>
  <div id="addstep">
    <Breadcrumb />

    <div class="container mb50">
      <p class="sub-title mt20">Artwork Preview</p>

      <PreviewPanel ref="previewpanel" :artwork="this.$store.state.artwork" />
    </div>
    <div class="nav-footer white font16">
      <span class="white click inlineb w10" @click="restart()">
        <i class="iconfont3 icon-reset"></i> RESTART
      </span>
      <span class="white click inlineb w10" @click="back()">
        <i class="iconfont3 icon-back"></i> BACK
      </span>

      <span
        v-if="!this.$store.state.artwork._id"
        class="orange click inlineb w10"
        @click="create()"
      >
        CREATE
        <i class="iconfont3 icon-next"></i>
      </span>
      <span v-if="this.$store.state.artwork._id" class="orange click inlineb w10" @click="save()">
        SAVE
        <i class="iconfont3 icon-next"></i>
      </span>
    </div>
  </div>
</template>

<script>
import "@/assets/css/project.css";
import Breadcrumb from "./Panel/Breadcrumb";
import axios from "axios";
import PreviewPanel from "./PreviewPanel";
import artworkToProductMixin from "../../mixins/artworkToProductMixin";

export default {
  name: "AlbaComplete",
  components: {
    Breadcrumb,
    PreviewPanel,
  },
  data() {
    return {};
  },
  mixins: [artworkToProductMixin],
  methods: {
    back() {
      this.$router.push({ path: "/collection/configuration/" + this.routeParamArtworkId});
    },
    restart() {
      this.$confirm("Are you sure you want to restart?", "Warning", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.$router.push({ path: "/collection" });
      });
    },
    async getScreenshoot() {
      const el = this.$refs.previewpanel.$refs.mypanel;
      const options = {
        type: "dataURL",
        scale: 2,
        backgroundColor: null
      };
      const output = await this.$html2canvas(el, options);
      const result = await fetch(output);
      const blob = await result.blob();
      return new File([blob], "screenshoot.png");
    },
    async save() {
      const formData = new FormData();
      const file = await this.getScreenshoot();
      formData.append("image", file);
      var sendData = Object.assign({}, this.$store.state.artwork);
      sendData.img = "";
      formData.append("state", JSON.stringify(sendData));
      if (this.isRouteParamProduct) {
        this.saveProduct(formData, this.routeParamProductId)
      } else {
        this.saveArtwork(formData);
      }
      
    },
    saveProduct(formData, pid) {
      axios
        .put("product/" + pid.replace('p', '') + "/artwork",
          formData,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true
          }
        )
        .then((res) => {
          if (res.data.ok == 1) {
            this.$router.push({ path: "/roomtype/" + res.data.value.rid });
          } else {
            this.$message({
              type: "error",
              message: "Edit Failed!",
            });
          }
        });
    },
    saveArtwork(formData) {
      axios
        .put("open/artwork/" +
            this.$store.state.artwork._id,
          formData,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
            withCredentials: false
          }
        )
        .then((res) => {
          if (res.data.ok == 1) {
            this.$router.push({ path: "/collection/complete/" + this.$store.state.artwork._id });
          } else {
            this.$message({
              type: "error",
              message: "Edit Failed!",
            });
          }
        });
    },
    createArtwork(formData) {
      axios
        .post("open/artwork", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
          withCredentials: false
        })
        .then((res) => {
          if (res.data.ok == 1) {
              this.$store.state.artwork = res.data.ops[0];
              this.$router.push({ path: "/collection/complete/" + res.data.insertedId});
          } else {
            this.$message({
              type: "error",
              message: "Create Failed!",
            });
          }
        });
    },
    createProduct(formData) {
      axios
        .post("/roomtype/" + this.$store.state.newArtworkToProductId + "/product", formData, {
          headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
          }})
        .then((res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Created!",
            });
            this.$router.push({ path: "/roomtype/" + this.$store.state.newArtworkToProductId });
            this.$store.state.newArtworkToProductId = null;
          } else {
            this.$message({
              type: "error",
              message: "Create Failed!",
            });
          }
        })
        .catch(function (error) {
          window.console.log(error);
        });
    },
    async create() {
      if (this.$store.state.user == null) {
        this.$store.state.artwork.uid = "anonymous";
      } else {
        this.$store.state.artwork.uid = this.$store.state.user._id;
      }
      const formData = new FormData();
      const file = await this.getScreenshoot();
      formData.append("image", file);
      var artwork = Object.assign({}, this.$store.state.artwork);
      artwork.img = "";
      if (this.$store.state.newArtworkToProductId != null) {
        var product = {
          quantity: 1,
          rid : this.$store.state.newArtworkToProductId,
          artwork: artwork
        }
        formData.append("state", JSON.stringify(product));
        this.createProduct(formData);
      } else {
        formData.append("state", JSON.stringify(artwork));
        this.createArtwork(formData);
      }
    },
  },

  created: function () {
    if (!this.$store.state.artwork.type) {
      alert("Please go to the start page");
      this.$router.push({ path: "/collection/" });
    }
    this.$parent.headerB();
    this.$parent.footerB();
    this.$parent.footerW();
    this.$store.state.current_step = 8;
  },
  computed: {},
};
</script>

<style lang="css" scoped>
.nav-footer{
  border-top:1px solid #ccc;
}
.nav-footer::before{
  content: '';
  display: block;
  width: 70%;
  height: 59px;
  position: absolute;
  top: 0;
  right: 15%;
}
</style>
